import React from 'react';
import { UserRole } from '../../types';

interface RoleCheckboxGroupProps {
  name: string;
  value: UserRole[];
  onChange: (roles: UserRole[]) => void;
  disabled?: boolean;
  error?: string;
}

const RoleCheckboxGroup: React.FC<RoleCheckboxGroupProps> = ({
  name,
  value = [],
  onChange,
  disabled = false,
  error,
}) => {

  const handleRoleChange = (role: UserRole, checked: boolean) => {
    if (checked) {
      // If selecting Security Guard, remove Packer, Receiver, and Admin
      if (role === UserRole.SECURITY) {
        onChange([UserRole.SECURITY]);
      }
      // If selecting Admin, remove Packer, Receiver, and Security Guard
      else if (role === UserRole.ADMIN) {
        onChange([UserRole.ADMIN]);
      }
      // If selecting Packer or Receiver, remove Security Guard and Admin
      else if (role === UserRole.PACKER || role === UserRole.RECEIVER) {
        const newRoles = value.filter(r => r !== UserRole.SECURITY && r !== UserRole.ADMIN);
        onChange([...newRoles, role]);
      }
    } else {
      // Simply remove the unchecked role
      onChange(value.filter(r => r !== role));
    }
  };

  return (
    <div>
      <div className="d-flex flex-column gap-3">
        {/* Top Section: Packer and Receiver */}
        <div className="p-2 border border-primary d-flex flex-row gap-3" style={{ background: '#e9e6ec' }}>
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id={`${name}-${UserRole.PACKER}`}
              checked={value.includes(UserRole.PACKER)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleRoleChange(UserRole.PACKER, e.target.checked)}
              disabled={disabled}
            />
            <label className="form-check-label text-primary" htmlFor={`${name}-${UserRole.PACKER}`}>
              Packer
            </label>
          </div>
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id={`${name}-${UserRole.RECEIVER}`}
              checked={value.includes(UserRole.RECEIVER)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleRoleChange(UserRole.RECEIVER, e.target.checked)}
              disabled={disabled}
            />
            <label className="form-check-label text-primary" htmlFor={`${name}-${UserRole.RECEIVER}`}>
              Receiver
            </label>
          </div>
        </div>

        {/* Middle Section: Security Guard */}
        <div className="p-2 border border-primary" style={{ background: '#e9e6ec' }}>
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id={`${name}-${UserRole.SECURITY}`}
              checked={value.includes(UserRole.SECURITY)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleRoleChange(UserRole.SECURITY, e.target.checked)}
              disabled={disabled}
            />
            <label className="form-check-label text-primary" htmlFor={`${name}-${UserRole.SECURITY}`}>
              Security Guard
            </label>
          </div>
        </div>

        {/* Bottom Section: Admin */}
        <div className="p-2 border border-primary" style={{ background: '#e9e6ec' }}>
          <div className="form-check mb-0">
            <input
              className="form-check-input"
              type="checkbox"
              id={`${name}-${UserRole.ADMIN}`}
              checked={value.includes(UserRole.ADMIN)}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleRoleChange(UserRole.ADMIN, e.target.checked)}
              disabled={disabled}
            />
            <label className="form-check-label text-primary" htmlFor={`${name}-${UserRole.ADMIN}`}>
              Admin
            </label>
          </div>
        </div>
      </div>
      
      {error && (
        <div className="text-danger mt-1" style={{ fontSize: '0.875rem' }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default RoleCheckboxGroup;
